import React, {useEffect, useState} from "react";
import Grid from "@material-ui/core/Grid";
import ListItemText from "@material-ui/core/ListItemText";
import {makeStyles} from "@material-ui/core";

const useStyles = makeStyles(() => ({
    editableField: {
        marginTop: '5px',
        marginBottom: '5px'
    }
}));

export const EditableField = ({editor, value, textValue, label, onChange, name, allowEdit = true}) => {

    const [edit] = useState(allowEdit);
    const [originalValue] = useState(value);
    const [currentValue, setCurrentValue] = useState(value);
    const [currentTextValue, setCurrentTextValue] = useState(textValue);

	const classes = useStyles();

    const handleEditorChanged = (e) => {

        let value = e.target.value;
        let textValue = value;
        if (e.target.tagName.toLowerCase() == 'selected') {
            const optionEl = e.target.querySelector('option[value="' + value + '"]');
            if (optionEl) {
                textValue = optionEl.innerHTML;
            } else {
                textValue = '';
            }
        }

        setCurrentValue(value);
        setCurrentTextValue(textValue);
    }

    useEffect(() => {

        if (onChange) {
            onChange({ name: name, value: currentValue, textValue: currentTextValue, originalValue: originalValue });
        }

        return () => { };
    }, [currentValue]);

    return (
        <>
            {!edit && <>
                <Grid item xs={12} className={classes.editableField}>
                   <ListItemText primary={label} secondary={currentTextValue} />
                </Grid>
            </>}
            {edit && <>
                <Grid item xs={12} className={classes.editableField}>
                {editor({label: label, value: currentValue, onChange: handleEditorChanged})}
                </Grid>
            </>}
        </>
    );
}